"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExposeEventObserver = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var types_1 = require("../types");
var processor_1 = require("../utils/processor");
var ExposeEventObserver = /** @class */ (function () {
    function ExposeEventObserver() {
    }
    ExposeEventObserver.prototype.update = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var items;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data.isImmediately) return [3 /*break*/, 2];
                        // 立即曝光情况下，需要先标记所有事件 isComplete: true
                        // 否则会有竞争状态，会导致这里写数据时把一些事件 isComplete 置为 false 了
                        return [4 /*yield*/, this.leaveOpsService.markEventsComplete()];
                    case 1:
                        // 立即曝光情况下，需要先标记所有事件 isComplete: true
                        // 否则会有竞争状态，会导致这里写数据时把一些事件 isComplete 置为 false 了
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        items = this.transform(data.items);
                        if (data.isManual) {
                            items = this.processManualExpose(items, data.posInfo);
                        }
                        this.handle({
                            items: items,
                            needPvid: data.needPvid,
                            isImmediately: data.isImmediately,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ExposeEventObserver.prototype.setLogService = function (service) {
        this.dispatchLogService = service;
    };
    ExposeEventObserver.prototype.transform = function (items) {
        return items
            .map(function (item) {
            var data = item.data, rest = __rest(item, ["data"]);
            var v4Data = (0, processor_1.processDataset)(item.data);
            // 如果没有 v4 数据，直接返回 undefined，会被过滤掉
            if (!v4Data) {
                return;
            }
            var result = __assign(__assign(__assign({}, v4Data), rest), { eventType: types_1.EventType.Expose });
            return result;
        })
            .filter(Boolean);
    };
    ExposeEventObserver.prototype.handle = function (options) {
        var _this = this;
        this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
            var items, needPvid, result;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        items = options.items, needPvid = options.needPvid;
                        result = items.map(function (item) {
                            var r = _this.mayAddPositionalInfo(item, needPvid);
                            return r;
                        });
                        result = result.map(function (item) { return _this.cleanBeforeSave(item); });
                        if (!result.length) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, ((_a = this.dispatchLogService) === null || _a === void 0 ? void 0 : _a.dispatch({
                                list: [
                                    {
                                        eventType: types_1.EventType.Expose,
                                        offset: 0,
                                        isComplete: true,
                                        listInfo: result,
                                    },
                                ],
                            }))];
                    case 1:
                        _b.sent();
                        if (!options.send) return [3 /*break*/, 3];
                        /**
                         * 如果标记了马上发送数据，则调用此方法。
                         * 原因在于 visibility hidden 时调用 core 内 exposeService.exposeImmediately，由于发送事件后才会到这里来，无法进行等待，
                         * 而 VisibilityEventObserver 可能已经调用了 uploadTimerService.dispatch，但没有获取到这部分数据，因此这里重新调用，
                         * 不会出现重复上报的原因是，pipeline 内的函数执行是顺序的，因此上一个上报如果把这里的数据报过了，那么数据会被标记为 shouldDelete: true
                         * 所以不会重复上报
                         */
                        return [4 /*yield*/, this.uploadTimerService.dispatch(true)];
                    case 2:
                        /**
                         * 如果标记了马上发送数据，则调用此方法。
                         * 原因在于 visibility hidden 时调用 core 内 exposeService.exposeImmediately，由于发送事件后才会到这里来，无法进行等待，
                         * 而 VisibilityEventObserver 可能已经调用了 uploadTimerService.dispatch，但没有获取到这部分数据，因此这里重新调用，
                         * 不会出现重复上报的原因是，pipeline 内的函数执行是顺序的，因此上一个上报如果把这里的数据报过了，那么数据会被标记为 shouldDelete: true
                         * 所以不会重复上报
                         */
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    ExposeEventObserver.prototype.cleanBeforeSave = function (data) {
        var target = data.target, pvid = data.pvid, absolutePosition = data.absolutePosition, needPosInfo = data.needPosInfo, rest = __rest(data, ["target", "pvid", "absolutePosition", "needPosInfo"]);
        return rest;
    };
    ExposeEventObserver.prototype.isNeedPositionalInfo = function (data) {
        return !!data.needPosInfo;
    };
    ExposeEventObserver.prototype.mayAddPositionalInfo = function (data, needPvid) {
        var result = data;
        if (this.isNeedPositionalInfo(data)) {
            result = this.addPositionalInfo(data, needPvid);
        }
        return result;
    };
    ExposeEventObserver.prototype.addPositionalInfo = function (data, needPvid) {
        var pvid = data.pvid, absolutePosition = data.absolutePosition, elementInfo = data.elementInfo, ei = data.ei, rest = __rest(data, ["pvid", "absolutePosition", "elementInfo", "ei"]);
        // 同时将 ei 和 elementInfo 组合到了一个字段
        var result = __assign(__assign({}, rest), { absolutePosition: absolutePosition, elementInfo: __assign({ absolutePosition: absolutePosition }, (elementInfo || ei)) });
        if (needPvid) {
            result.pvid = pvid;
            if (result.elementInfo) {
                result.elementInfo.pvid = pvid;
            }
        }
        return result;
    };
    ExposeEventObserver.prototype.mayAddPosInfoToManualListInfoItem = function (listItem, posInfo) {
        var ei = listItem.ei || listItem.elementInfo;
        if (listItem.needPosInfo) {
            return __assign(__assign({}, listItem), { elementInfo: __assign(__assign(__assign({}, posInfo), ei), { absolutePosition: (ei === null || ei === void 0 ? void 0 : ei.ap) || (ei === null || ei === void 0 ? void 0 : ei.absolutePosition) || (posInfo === null || posInfo === void 0 ? void 0 : posInfo.absolutePosition) || 0 }) });
        }
        return listItem;
    };
    ExposeEventObserver.prototype.processManualExpose = function (data, posInfo) {
        var _this = this;
        var result = [];
        (data || []).forEach(function (item) {
            var _a, _b, _c;
            var usedKey = "li";
            if (item.li) {
                usedKey = "li";
            }
            else if (item.listInfo) {
                usedKey = "listInfo";
            }
            var liItem = (_a = item[usedKey]) === null || _a === void 0 ? void 0 : _a[0];
            var transformedItem = _this.mayAddPosInfoToManualListInfoItem(liItem || {}, posInfo);
            // 再将这三个值放在顶层，与 IExposedItem 结构类似，不会存到 localstorage
            transformedItem.absolutePosition =
                ((_b = transformedItem.elementInfo) === null || _b === void 0 ? void 0 : _b.absolutePosition) || (posInfo === null || posInfo === void 0 ? void 0 : posInfo.absolutePosition) || 0;
            transformedItem.pvid = ((_c = transformedItem.elementInfo) === null || _c === void 0 ? void 0 : _c.pvid) || (posInfo === null || posInfo === void 0 ? void 0 : posInfo.pvid) || "";
            result.push(transformedItem);
        });
        return result;
    };
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IApplicationExecutor),
        __metadata("design:type", Object)
    ], ExposeEventObserver.prototype, "applicationExecutor", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.ILeaveOpsService),
        __metadata("design:type", Object)
    ], ExposeEventObserver.prototype, "leaveOpsService", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IUploadTimerService),
        __metadata("design:type", Object)
    ], ExposeEventObserver.prototype, "uploadTimerService", void 0);
    ExposeEventObserver = __decorate([
        (0, inversify_1.injectable)()
    ], ExposeEventObserver);
    return ExposeEventObserver;
}());
exports.ExposeEventObserver = ExposeEventObserver;
